export default "__VITE_ASSET__D0SsAhF8__"